import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Wind, ArrowRight } from 'lucide-react';
interface SplashScreenProps {
  onComplete: (destination: 'dashboard' | 'ritual') => void;
  onOpenLogin: () => void;
}
export function SplashScreen({
  onComplete,
  onOpenLogin
}: SplashScreenProps) {
  const [isStarted, setIsStarted] = useState(false);
  const [statusText, setStatusText] = useState('Zatrzymaj się na chwilę.');
  const handleStart = (destination: 'dashboard' | 'ritual') => {
    if (isStarted) return;
    setIsStarted(true);
    // Trigger vibration
    try {
      if (navigator.vibrate) {
        navigator.vibrate([200, 100, 200]);
      }
    } catch (e) {
      console.log('Vibration API not supported');
    }
    // Trigger audio
    try {
      const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
      const audioContext = new AudioContext();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = 528;
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      const now = audioContext.currentTime;
      gainNode.gain.setValueAtTime(0, now);
      gainNode.gain.linearRampToValueAtTime(0.3, now + 2);
      gainNode.gain.exponentialRampToValueAtTime(0.001, now + 5.5);
      oscillator.start(now);
      oscillator.stop(now + 6);
    } catch (e) {
      console.log('Audio API not supported');
    }
    // Text change sequence
    setTimeout(() => {
      setStatusText('Harmonizacja przestrzeni...');
    }, 500);
    // Complete sequence and navigate
    setTimeout(() => {
      onComplete(destination);
    }, 4500);
  };
  return <motion.div className="flex flex-col items-center justify-center text-center w-full max-w-md relative z-10 p-4 min-h-[100dvh]" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0,
    transition: {
      duration: 1
    }
  }} data-id="element-974">
      <div className="flex-1 flex flex-col items-center justify-center w-full" data-id="element-975">
        <div className="relative w-48 h-48 mb-10 flex items-center justify-center animate-float" data-id="element-976">
          <div className={`absolute w-full h-full rounded-full border border-zen-accent opacity-0 ${isStarted ? 'animate-ripple' : ''}`} data-id="element-977"></div>
          <div className={`absolute w-full h-full rounded-full border border-zen-accent opacity-0 ${isStarted ? 'animate-ripple' : ''}`} style={{
          animationDelay: '1s'
        }} data-id="element-978"></div>

          <div className="relative z-10 w-24 h-24 rounded-full bg-zen-bg border-2 border-zen-accent shadow-[0_0_30px_rgba(188,163,127,0.2)] flex items-center justify-center transition-transform hover:scale-105 duration-500" data-id="element-979">
            <Wind className="text-zen-accent w-10 h-10" strokeWidth={1.5} data-id="element-980" />
          </div>
        </div>

        <h1 className="text-4xl font-light tracking-widest mb-2 text-zen-text" data-id="element-981">
          AuraSync
        </h1>
        <p className="text-zen-accent text-sm mb-12 tracking-widest uppercase text-[10px] font-semibold" data-id="element-982">
          Twój Osobisty Dobrostan
        </p>

        <p className={`text-lg font-light mb-8 h-8 transition-opacity duration-500 ${isStarted ? 'gold-gradient-text opacity-100' : 'text-slate-500'}`} data-id="element-983">
          {statusText}
        </p>

        <div className={`w-full flex flex-col space-y-4 px-4 transition-all duration-500 ${isStarted ? 'opacity-0 pointer-events-none scale-95' : 'opacity-100 scale-100'}`} data-id="element-984">
          <button onClick={() => handleStart('ritual')} className="w-full bg-zen-sage text-white rounded-full py-4 text-sm font-bold hover:bg-zen-sage/90 transition-colors shadow-lg shadow-zen-sage/20 flex items-center justify-center space-x-2" data-id="element-985">
            <span data-id="element-986">Rozpocznij Rytuał Dnia</span>
            <ArrowRight className="w-4 h-4" data-id="element-987" />
          </button>
          <button onClick={() => handleStart('dashboard')} className="w-full clean-panel text-slate-600 rounded-full py-4 text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-988">
            Przejdź do Kokpitu
          </button>
        </div>
      </div>

      <div className={`mt-auto pb-8 transition-opacity duration-500 ${isStarted ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} data-id="element-989">
        <button onClick={onOpenLogin} className="text-xs font-semibold text-slate-400 hover:text-zen-accent uppercase tracking-widest transition-colors" data-id="element-990">
          Zaloguj się
        </button>
      </div>
    </motion.div>;
}